import React, { HTMLAttributes, useMemo } from 'react';

import { Collapse, makeStyles } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/WarningRounded';
import cn from 'classnames';

const useStyles = makeStyles({
  container: {
    position: 'relative',
    width: '100%',
    padding: '8px 12px',

    display: 'grid',
    gridTemplateColumns: '24px 1fr',
    gridColumnGap: '12px',

    borderRadius: '5px',

    fontSize: '11px',
    color: '#00363D',
  },
  containerInfo: {
    backgroundColor: '#EFF5F5',
  },
  containerWarning: {
    backgroundColor: '#ECD370',
  },
  containerDanger: {
    backgroundColor: '#cc0044',
    color: '#fff',
  },
  iconHolder: {
    paddingTop: '2px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',

    color: '#4BB4B3',
    fontSize: '20px',
  },
  iconHolderDanger: {
    color: '#fff',
  },
  iconHolderWarning: {
    color: '#00363D',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    '& p': {
      margin: 0,
    },
  },
});

interface IOVAlert extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  type?: 'danger' | 'info' | 'warning';
  isOpen?: boolean;
  style?: any;
}

const OVAlert = ({
  children,
  type = 'danger',
  isOpen = true,
  style = {},
  ...restProps
}: IOVAlert) => {
  const classes = useStyles();

  const elClassName = useMemo(
    () =>
      cn(classes.container, {
        [classes.containerDanger]: type === 'danger',
        [classes.containerInfo]: type === 'info',
        [classes.containerWarning]: type === 'warning',
      }),
    [classes, type],
  );

  const iconClassName = useMemo(
    () =>
      cn(classes.iconHolder, {
        [classes.iconHolderDanger]: type === 'danger',
        [classes.iconHolderWarning]: type === 'warning',
      }),
    [classes, type],
  );

  return (
    <Collapse in={isOpen}>
      <div className={elClassName} style={style} {...restProps}>
        <div className={iconClassName}>
          <WarningIcon color="inherit" fontSize="inherit" />
        </div>
        <div className={classes.content}>{children}</div>
      </div>
    </Collapse>
  );
};

export default OVAlert;
